module.exports = __webpack_public_path__ + "img/115fc4bbc0faa93d97cd7990be083c78.png";